module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-four",
    class: 'theme-' + _vm.theme
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": "click",
      "gtm-event-action": "Scroll Article/Click/Also Read",
      "gtm-event-label": ("" + (_vm.node.relative_url))
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a17e7a24","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article-levels/Lv4.vue
// module id = 1047
// module chunks = 1 3 4 5